
import React from 'react'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'
import PrimarySection from './Section/Primary'

const RateParameter = ({ disable_name, ...props }) =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={1}>
      <Grid size={12}><FormHeader /></Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[1]} activeStep={0} orientation={'vertical'}>
          <Step> <PrimarySection disable_name={disable_name} /> </Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(RateParameter)
